"use client"
import React from 'react'

function error() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-5 text-center bg-gray-50">
      <div className="max-w-md mx-auto p-8">
        <div className="mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 mx-auto text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-2">500 Error</h1>
        <p className="text-lg text-gray-600">Something went wrong</p>
      </div>
    </div>
  )
}

export default error